import startDeepZoomImage from "../deepzoom-exercise";


function hideModal($modal, $body) {
  $body.removeClass('no-scroll');
  $modal.hide();


}

function bindModalButtons() {
  const $modal = $(".modal");
  const $body = $("body");
  $('.exercise__action').on('click', function () {

    if($(this).hasClass('exercise__mobile')) {
      console.log('mobile');
      return;
    }

    if($(this).hasClass('exercise__action--external')) {

      window.location = $(this).data('href');

      return;
    }

    if ($modal.css('display') === "none") {
      $modal.css('display', "flex");
      window.dispatchEvent(new Event('resize'));
      $body.addClass('no-scroll');
      return true;
    }
    return hideModal($modal, $body)
  })

  $("#close-button").on('click', function () {
    return hideModal($modal, $body);
  })
}


export default {

  init() {

    bindModalButtons()

    if (gameId === "wimmelbild") {
      console.info('start game wimmelbild');
      startDeepZoomImage()
    }

    const $allTexts = $(".exercise__description__element__text");

    // JavaScript to be fired on the home page
    $(".exercise__element--trigger").on('click', function (e) {

      if($(e.target).closest('.exercise__description__element').hasClass('exercise__element--open')) {
        
        $('.exercise__element--open').removeClass('exercise__element--open').find('.exercise__description__element__text').slideUp();

        return;
      }
      
      $('.exercise__element--open').removeClass('exercise__element--open');
      $allTexts.slideUp();
      $(e.target).closest('.exercise__description__element').toggleClass('exercise__element--open').find('.exercise__description__element__text').width('100%').slideDown(300)
    })

  },
  finalize() {
    // JavaScript to be fired on the home page, after the init JS
  },
};



// WEBPACK FOOTER //
// ./scripts/routes/exercise.js